function trimLeadingSlash(path: string): string {
  return path.startsWith("/") ? path.slice(1) : path;
}

export function getNodePublicAssetRoot(currentDirName?: string): string {
  if (currentDirName?.includes(".next")) {
    return "public";
  }

  return "apps/web/public";
}

export function getNodePublicAssetPath(assetPath: string, currentDirName?: string): string {
  return `${getNodePublicAssetRoot(currentDirName)}/${trimLeadingSlash(assetPath)}`;
}
